import CTAButton from "./CTAButton";

export default function GuaranteeSection({ content = {}, onCheckout, canCheckout }) {
  const title = content.title || "Kenapa Harus Pesan Hari Ini?";
  const items = content.items || [];

  return (
    <section className="py-20 lg:py-28 bg-gradient-soft">
      <div className="mx-auto max-w-6xl px-5">
        <div className="text-center max-w-2xl mx-auto">
          <span className="text-xs font-bold uppercase tracking-widest text-primary">Garansi & Kepercayaan</span>
          <h2 className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-bold text-balance">
            {title}
          </h2>
        </div>

        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {items.map((item, i) => (
            <div
              key={i}
              className="rounded-3xl bg-white border border-border p-6 text-center shadow-card hover:shadow-luxury hover:-translate-y-1 transition-all"
            >
              <div className="text-4xl">{item.icon || "🎁"}</div>
              <div className="mt-3 font-bold">{item.title}</div>
              <div className="text-xs text-muted-foreground mt-1">{item.desc}</div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <CTAButton size="lg" onClick={onCheckout} disabled={!canCheckout}>
            🔥 Pesan Sekarang Juga
          </CTAButton>
        </div>
      </div>
    </section>
  );
}
